import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsEC: CultureInfo = {
  name: 'es-EC',
  displayName: 'Spanish (Ecuador)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-EC',
  parent: CultureInfoEs
};
